// 选择订单
import SelectOrder from '../components/SelectOrder/index.vue'
// 租赁设置
import LeaseSetup from '../components/LeaseSetup/index.vue'
// 绑定车辆
import BoundVehicles from '../components/BoundVehicles/index.vue'
// 完成
import SignSuccess from '../components/SignSuccess/index.vue'
// 订单支付
import OrderPayment from '../components/OrderPayment/index.vue'
// 发车验车
import OperationOutIn from '../components/OperationOutIn/index.vue'
// 全部流程完成
import ProcessSuccess from '../components/ProcessSuccess/index.vue'

export default function () {
  const stepsList = [
    {
      id: 0,
      title: '选择主订单',
      component: SelectOrder,
      isShow: true,
    },
    {
      id: 1,
      title: '租赁设置',
      component: LeaseSetup,
      isShow: true,
    },
    {
      id: 2,
      title: '绑定车辆',
      component: BoundVehicles,
      isShow: true,
    },
    {
      id: 3,
      title: '完成',
      component: SignSuccess,
      isShow: true,
    },
  ]
  const fillStepList = [
    {
      id: 0,
      title: '选择主订单',
      component: SelectOrder,
      isShow: true,
    },
    {
      id: 1,
      title: '租赁设置',
      component: LeaseSetup,
      isShow: true,
    },
    {
      id: 2,
      title: '绑定车辆',
      component: BoundVehicles,
      isShow: true,
    },
    {
      id: 3,
      title: '订单支付',
      component: OrderPayment,
      isShow: false,
    },
    {
      id: 4,
      title: '发车验车',
      component: OperationOutIn,
      isShow: false,
    },
    {
      id: 5,
      title: '完成',
      component: ProcessSuccess,
      isShow: true,
    },
  ]
  return {
    stepsList,
    fillStepList,

  }
}
